import ApiServiceV6Core from '@/helpers/api.service.v6core';
const APIV6Core = new ApiServiceV6Core();


export const state = {
   
}

export const mutations = {
    
}

export const actions = {
    actionCoreEloadNetworkAPIPOST(_, {params, action}) {
        return new Promise((resolve, reject) => {
            // console.log("actionCoreEloadNetworkAPIPOST params:", params);
            // Use normal API service (with preloader)
            APIV6Core.post(`/eload/network/${action}`, params)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
        });
    },
}

export const getters = {
    
}